module.exports = __webpack_public_path__ + "img/infodesk_mobile.3aaf755f.svg";